var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6449 3.77856C32.4201 4.3069 31.0873 4.68715 29.7144 4.83524C31.1398 3.98843 32.2072 2.65062 32.7163 1.0728C31.3788 1.86847 29.9135 2.42641 28.3855 2.72187C27.7469 2.03913 26.9745 1.49523 26.1165 1.12406C25.2584 0.752892 24.3332 0.562405 23.3983 0.56447C19.6158 0.56447 16.5739 3.63046 16.5739 7.3929C16.5739 7.92124 16.6379 8.44959 16.742 8.95792C11.0783 8.66172 6.02702 5.95597 2.66884 1.81328C2.05694 2.85842 1.73629 4.04843 1.74023 5.25952C1.74023 7.62905 2.94502 9.71841 4.78221 10.9472C3.69952 10.9046 2.64219 10.607 1.69621 10.0786V10.1627C1.69621 13.4809 4.04173 16.2306 7.16776 16.863C6.58081 17.0155 5.97701 17.0935 5.37059 17.0952C4.9263 17.0952 4.50603 17.0512 4.08175 16.9911C4.94631 19.6969 7.46395 21.6622 10.4619 21.7262C8.11637 23.5634 5.17846 24.6441 1.98839 24.6441C1.41602 24.6441 0.887681 24.6241 0.339325 24.56C3.36529 26.5013 6.95562 27.622 10.8221 27.622C23.3743 27.622 30.2427 17.2233 30.2427 8.19742C30.2427 7.90123 30.2427 7.60504 30.2227 7.30885C31.5516 6.33622 32.7163 5.13143 33.6449 3.77856Z",
    fill: "#2091F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb3);
export default __webpack_public_path__ + "static/media/fb3.2cd78c2e5a91da4e2ffa71ea1498516b.svg";
export { ForwardRef as ReactComponent };